import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./Store/AuthContext";
import $ from "jquery";

import "font-awesome/css/font-awesome.min.css";

window.$ = $;
window.jQuery = $;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthProvider>
    <App />
  </AuthProvider>
);
